import React,{ useRef } from 'react';
import axios from 'axios'
import { Tooltip,Popover,Result,Table,Popconfirm,Input, Button,Collapse,Card,Avatar,Modal,Form,DatePicker,Select,Space,Typography,Divider,InputNumber,message,Spin,Switch } from 'antd';
import Highlighter from 'react-highlight-words';
import Icon, { PrinterOutlined, MinusOutlined, CloseCircleFilled, CheckCircleOutlined, UserOutlined } from '@ant-design/icons';
import { DeleteOutlined,SearchOutlined,CameraOutlined,PlusOutlined,EditOutlined,PlusSquareFilled,SaveOutlined,LoadingOutlined } from '@ant-design/icons';
import QrReader from 'react-qr-reader'
import uuid from 'react-uuid'
import PhoneInput from 'react-phone-number-input'
import moment from 'moment';
import PrintTemplate from 'react-print';
import ReactToPrint from 'react-to-print';
import {
  Col,
  Row,
} from 'reactstrap';
import CurrencyFormat from 'react-currency-format';
import * as serverconfig from '../serverconn'
import * as reactstrp from 'reactstrap';
import { ToWords } from 'to-words';

var CryptoJS = require("crypto-js");

const { Panel } = Collapse;
const FormItem=Form.Item;
const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';
const { Title } = Typography;
const { TextArea } = Input;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

const toWords = new ToWords();

message.config({
  top: 200,
  duration: 2,
  maxCount: 3,
  rtl: true,
});

var token= ''
var sacco= ''
var username=''
var bizuserid= ''

class MemberPayments_PayOutEntryView extends React.Component {

  state = {
    date:moment().format(dateFormat).toString(),
    selectedmember_account:'',
    selectedmember_accountobject:{},
    members:[],
    datarequested:true,
    totalamount:0,
    fixedrate:0,
    previoustransactions:[],
    datasubmittedsuccessfully:false,
    fixedamount:0,
    companyprofile:{},
    accountchange:false,
    userprofile:{},
    fdperiod:0,
    fixedratetype:'simple',

    companyaccounts: [],
    credit_account:'',
    transaction_description:'',
    transaction_amount:0,
    transaction_type:'',
    journal_list:[],
    itemnumber:0,
    debit_account:'',
    credit_savings:false,
    send_message:false


  }

  callback(key) {
    console.log(key);
  }

  componentDidMount(){
    if(localStorage.getItem("sacco")){
       sacco= CryptoJS.AES.decrypt(localStorage.getItem("sacco") , 'my-secret-key@12345').toString(CryptoJS.enc.Utf8)
       username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
    
    }else{
       sacco= ''
       username=''
    }
    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("bizuserid")){
      bizuserid= CryptoJS.AES.decrypt(localStorage.getItem("bizuserid") , 'my-secret-key@1234').toString(CryptoJS.enc.Utf8)
   }else{
      bizuserid= ''
   }

    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }

    let form_data1 = new FormData();
    form_data1.append('userid', bizuserid);
    
    //get the user profile here
    axios.post(serverconfig.backendserverurl+'/customqueries/get_user_profile',form_data1,{
      headers: {
        'content-type': 'multipart/form-data'
      }
      })
    .then(res => {
        this.setState({
          userprofile:res.data
        })
     
    })


    axios.get(`${serverconfig.backendserverurl}/api/saccos/${sacco}`)
    .then(res => {  
        this.setState({
          companyprofile: res.data
        })
    })


    axios.get(serverconfig.backendserverurl+`/api/members/?sacco=${sacco}`)
    .then(res => {
      //console.log(res.data)
        this.setState({
          members:res.data
        })

    })

    axios.get(serverconfig.backendserverurl+`/api/companyaccounts/?sacco=${sacco}`)
    .then(res => {
        this.setState({
            companyaccounts:res.data
        })
        this.setState({datarequested:false})
    })

  }
  

  //submit the deposit now
  handleFormSubmit=(event) =>{

    if (this.calculateTotalCredit()!=this.calculateTotalDebit()){
      message.info(" Debit must be equal to credit ")
    }
    else{
      
    }
    
  }



  ////////////////////////////////////////////
  // RENDERING METHOD HERE
  render() {


    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      if(this.state.datasubmittedsuccessfully===true){
        return(
          <div>

            <Row >
                <Col xs="12" sm="6" lg="6">
                  <Card>
                  <Result
                  status="success"
                  title="Successful payment entry"
                  subTitle="Finish off transaction"
                  extra={[
                    <Button  type='primary' onClick={()=>{window.location.reload(false)}}>Finish</Button>,
                  ]}
                  />

                  </Card>

                  </Col>

            </Row>
          </div>

        )

      }else{
        return(
          <div>
      
        <Card>
        <h4>Member payout form</h4>
        <Form 
          name="Ledger account"
          onFinish={(event) => {

            if (this.state.credit_account===""){
              message.error("Credit account cant be missing")
            }else if(this.state.transaction_amount<=0){
              message.error("Transaction amount cant be less or equal to zero")

            }else if(this.state.transaction_description===""){
              message.error("Transaction details cant be missing")

            }else if(this.state.selectedmember_account===""){
              message.error("Member account cant be missing")

            }else if (this.state.debit_account===""){
              message.error("Debit (Expense) account cant be missing")

            }else{


              this.setState({datarequested:true})
  
              let form_data = new FormData();
              form_data.append('date',this.state.date);
              form_data.append('sacco', sacco);
              form_data.append('username', username);
              form_data.append('selectedmember_account',this.state.selectedmember_account);
        
              form_data.append('transaction_amount',this.state.transaction_amount);
              form_data.append('transaction_description',this.state.transaction_description);

              form_data.append('credit_account',this.state.credit_account);
              form_data.append('debit_account',this.state.debit_account);

              //credit savings
              form_data.append('credit_savings',this.state.credit_savings);
              form_data.append('send_message',this.state.send_message);

              axios.post(serverconfig.backendserverurl+'/customqueries/creatememberpayout_expense', form_data, {
                headers: {
                  'content-type': 'multipart/form-data'
                } })
              .then(res => {
                this.setState({datarequested:false})
                message.info(res.data.message)
                if (res.data.message==="success"){
                  this.setState({datasubmittedsuccessfully:true})
                }
                
              })
              .catch(error => console.log(error))

            }
            
          }}
          >


          {
            this.state.companyprofile.automated_transaction_date===false?
            <FormItem label="Date of entry"
            name='date'
            rules={[
              {
                required: true,
                message: 'Please Select date',
              },
              ]}
            >
                <DatePicker value={moment()} onChange={(date, dateString) => this.setState({ date: dateString})} format={dateFormat} />
            </FormItem>                 
            :
            null
          }


    <FormItem label={"Debit account (Expense)"}>
              <Select 
              placeholder="Debit Account" 
              style={{  }} 
              value={this.state.debit_account}
              onChange={(val)=>{this.setState({debit_account:val})}} 
              showSearch
              optionFilterProp="children"
              onFocus={this.onFocus}
              onBlur={this.onBlur}
              onSearch={this.onSearch}                    
              >
                {this.state.companyaccounts.map(
                  (accnt)=>(
                    <Option value={accnt.account_name}>{accnt.account_name} | {accnt.account_code} | {accnt.account_type}</Option>
                  ))}
              </Select>
          </FormItem>


        <FormItem label={"Credit account"}>
          <Select 
          placeholder="Credit Account" 
          style={{  }} 
          value={this.state.credit_account}
          onChange={(val)=>{this.setState({credit_account:val})}} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}                    
          >
            {this.state.companyaccounts.map(
              (accnt)=>(
                <Option value={accnt.account_name}>{accnt.account_name} | {accnt.account_code} | {accnt.account_type}</Option>
              ))}
          </Select>
      </FormItem>



       <FormItem label="Amount">
          <Input name="transaction_amount" type="number" placeholder="Transaction amount" value={this.state.transaction_amount} onChange={(val)=>{this.setState({transaction_amount:val.target.value})}} />
        </FormItem>

        <FormItem label="Transaction details"
          
        >
              <TextArea
                    placeholder="Details."
                    autoSize={{ minRows: 2, maxRows: 6 }}
                    value={this.state.transaction_description}
                    onChange={(val)=>{this.setState({transaction_description:val.target.value})}}
                  />
        </FormItem>


        <FormItem label="Member account">
            <Select 
            placeholder="Account No | Name" 
            style={{  }} 
            value={this.state.selectedmember_account}
            onChange={(e)=>{
              this.setState({ selectedmember_account: e});
              //make query for last transactions
              axios.get(`${serverconfig.backendserverurl}/api/members/${e}`)
                .then(res => {  
                    this.setState({selectedmember_accountobject: res.data})
                })
            }} 
            showSearch
            optionFilterProp="children"
            onFocus={this.onFocus}
            onBlur={this.onBlur}
            onSearch={this.onSearch}                    
            >
              {this.state.members.map(
                (accnt)=>(
                  <Option value={accnt.id}>{accnt.AccountNumber} | {accnt.FullName}</Option>
                ))}
            </Select>
        </FormItem>

        <FormItem label="Credit member savings?">
            <Switch
                checked={this.state.credit_savings}
                onChange={val=>{this.setState({credit_savings:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>

        <FormItem label="Send SMS message?">
            <Switch
                checked={this.state.send_message}
                onChange={val=>{this.setState({send_message:val})}}
                checkedChildren="True"
                unCheckedChildren="False"
                />
        </FormItem>


        <FormItem>
          <Button  type="primary" htmlType="submit">Create payment</Button>
        </FormItem>

        </Form>

        </Card>

        </div>                       
        )
      }
    }
   
  }
}

export default MemberPayments_PayOutEntryView; 
